import { api } from "../base";

export interface ApiKey {
  venue_api_key_id: string;
  account_id: string;
  portfolio_id: string;
  key: { venue: string; [field: string]: unknown };
  is_active: boolean;
  [rest: string]: unknown;
}

interface ApiKeysResponse {
  keys?: ApiKey[];
  data?: ApiKey[];
}

const apiKeysEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Fetches API keys for a venue account. */
    getApiKeys: build.query<ApiKey[], string>({
      query: (accountId) => ({
        url: `/api/account/v1/venue_accounts/${accountId}/apikeys`,
      }),
      transformResponse: (response: ApiKeysResponse) =>
        response?.keys ?? response?.data ?? [],
      providesTags: (_result, _error, accountId) => [
        { type: "ApiKeys", id: accountId },
      ],
    }),

    /** Saves (creates) an API key for a venue account. */
    saveApiKey: build.mutation<
      void,
      { accountId: string; payload: Record<string, unknown> }
    >({
      query: ({ accountId, payload }) => ({
        url: `/api/account/v1/venue_accounts/${accountId}/apikeys`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { accountId }) => [
        { type: "ApiKeys", id: accountId },
      ],
    }),

    /** Deletes an API key. */
    deleteApiKey: build.mutation<
      void,
      { accountId: string; keyId: string }
    >({
      query: ({ accountId, keyId }) => ({
        url: `/api/account/v1/venue_accounts/${accountId}/apikeys/${keyId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, { accountId }) => [
        { type: "ApiKeys", id: accountId },
      ],
    }),
  }),
});

export const {
  useGetApiKeysQuery,
  useLazyGetApiKeysQuery,
  useSaveApiKeyMutation,
  useDeleteApiKeyMutation,
} = apiKeysEndpoints;
